import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { Card } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight, faFilePdf } from '@fortawesome/free-solid-svg-icons';
import { setCurrentTab } from 'redux/reducers/fluxUploadLayoutReducer';
import { openRight } from 'redux/reducers/sidebarsReducer';
import GuideCard from 'components/Flux/Upload/Mobile/Form/GuideCard';
import FluxFileUploadFormMobile from 'components/Flux/Upload/Mobile/Form';
import useIsMobile from 'utils/hooks/useIsMobile';
import { UPLOAD_GUIDE_TAB_URL } from 'helper/flux/about';
import './index.scss';

export default function New() {
  const dispatch = useDispatch();
  const isMobile = useIsMobile();

  useEffect(() => {
    dispatch(openRight());
    dispatch(setCurrentTab('new'));
  }, [dispatch]);

  if (isMobile) {
    return (
      <div className="new-upload-mobile">
        <GuideCard />
        <FluxFileUploadFormMobile />
      </div>
    );
  }

  return (
    <>
      <Card className="new-upload-card shadow-sm">
        <Card.Body>
          <div className="new-upload-guide">
            <FontAwesomeIcon icon={faFilePdf} className="new-upload-guide-icon" />
            <h2 className="new-upload-guide-title">
              Guia do Estudos Upload — smapR v1.4.1
            </h2>
            <p className="new-upload-guide-text">
              Formatos aceitos, exigências do arquivo zip, nomeação dos arquivos e exemplos
              prontos. O material completo fica em
              {' '}
              <b>Sobre › Estudos Upload</b>
              .
            </p>
            <Link to={UPLOAD_GUIDE_TAB_URL} className="new-upload-guide-link">
              Abrir o guia (PDF)
              <FontAwesomeIcon icon={faArrowRight} />
            </Link>
          </div>
        </Card.Body>
      </Card>
      <div className="p-4" />
    </>
  );
}
